<lui-expansion-panel #panel class="expansion-panel--alternative rounded-1">
  <lui-expansion-panel-header>
    <lui-avatar color="grayMedium" size="48px">
      <mat-icon svgIcon="product_info_thin"></mat-icon>
    </lui-avatar>
    <span class="mat-body-strong ms-1" i18n>{{ title }}</span>
    <mat-icon
      class="ms-auto proposal-product-details__chevron"
      [svgIcon]="panel.expanded ? 'chevron_up' : 'chevron_down'"
    ></mat-icon>
  </lui-expansion-panel-header>
  <lui-expansion-panel-content class="d-flex flex-column p-2">
    <p class="mb-2">{{ description }}</p>

    <ng-container *ngFor="let cob of cobs; let last = last">
      <div class="d-flex flex-column" *ngrxLet="cob | cobMeta as product">
        <div class="d-flex mb-1">
          <lui-avatar [color]="product.color" size="48px">
            <mat-icon [svgIcon]="product.icon"></mat-icon>
          </lui-avatar>
          <div class="proposal-product-details__details ps-2">
            <p
              class="proposal-product-details__name d-flex mat-body-strong my-1"
            >
              {{ product.title }}
            </p>
            <span class="mat-small">{{ product.description }}</span>
          </div>
        </div>
        <a
          *ngIf="product.externalLink"
          [href]="product.externalLink"
          class="proposal-product-details__link mb-_5 d-block ms-auto"
          target="_blank"
          size="xs"
          luiIconButton
        >
          <mat-icon svgIcon="chevron_right_thin"></mat-icon>
        </a>
      </div>

      <div *ngIf="!last" class="lui-expansion-panel-divider mb-2"></div>
    </ng-container>
  </lui-expansion-panel-content>
</lui-expansion-panel>
